import { metrics } from '@opentelemetry/api'
import { AggregationTemporalityPreference, OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http'
import { Resource } from '@opentelemetry/resources'
import { MeterProvider, PeriodicExportingMetricReader } from '@opentelemetry/sdk-metrics'

import env from '../../../env'

export const setupMeterProvider = (resource: Resource) => {
    const metricReader = new PeriodicExportingMetricReader({
        exporter: new OTLPMetricExporter({
            url: env.VITE_OTEL_METRICS_ENDPOINT,
            // Ephemeral browser clients must emit delta counters so the collector can reconcile them into
            // cumulative. Cumulative-per-client collides on one series and inflates increase()/rate().
            temporalityPreference: AggregationTemporalityPreference.DELTA,
        }),
        exportIntervalMillis: 60000, // Push metrics every 60s
    })

    const meterProvider = new MeterProvider({
        resource: resource,
        readers: [metricReader],
    })

    metrics.setGlobalMeterProvider(meterProvider)

    // Flush metrics on page hide/unload to ensure we capture data
    // even if the user leaves before the next scheduled export
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            void meterProvider.forceFlush()
        }
    })
}
